import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OrganizationEntity } from '@taxora-api-models';
import { Section } from '@taxora-shared-common/ui/section/section';
import { FallbackValuePipe } from '@taxora-shared-common/util';

@Component({
  selector: 'lib-organization-details',
  imports: [CommonModule, TranslatePipe, FallbackValuePipe, Section],
  templateUrl: './organization-details.html',
  styleUrl: './organization-details.scss',
})
export class OrganizationDetails {
  public readonly organization = input<OrganizationEntity | null>(null, { alias: 'value' });
  protected readonly TRANSLATION_PATH = 'common.organizationDetails.';
}
